import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgRemoveAttachmentLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7549 0.00244141C17.1304 0.00244141 16.5121 0.126552 15.9359 0.367613C15.3597 0.608626 14.837 0.961673 14.3981 1.40641L14.3954 1.40917L11.7658 4.09438L11.7654 4.09476L9.36145 6.5469L10.7743 7.96266L13.1939 5.49449L13.1943 5.49411L15.8216 2.81128L15.8228 2.81003C16.0756 2.55428 16.3763 2.35129 16.7077 2.21267C17.0395 2.07388 17.3954 2.00244 17.7549 2.00244C18.1144 2.00244 18.4703 2.07388 18.8021 2.21267C19.1317 2.35055 19.431 2.55211 19.6829 2.80593C20.1978 3.34663 20.4856 4.06594 20.4856 4.81449C20.4856 5.56235 20.1984 6.28093 19.6842 6.82149L15.6921 10.8219L15.692 10.8218L15.6832 10.8309L14.6729 11.8693L16.0858 13.2851L17.1122 12.2302L21.1077 8.22639L21.1151 8.21906L21.1222 8.21158C21.9974 7.29752 22.4856 6.08033 22.4856 4.81449C22.4856 3.54869 21.9974 2.33137 21.1222 1.41728L21.117 1.41181L21.1116 1.40641C20.6727 0.961673 20.15 0.608626 19.5739 0.367613C18.9977 0.126552 18.3794 0.00244141 17.7549 0.00244141ZM14.691 14.7188L13.2781 13.303L8.69462 18.014C8.52574 18.1742 8.30215 18.2633 8.06982 18.2633C7.84133 18.2633 7.62132 18.1771 7.45341 18.0218C7.28871 17.8379 7.19702 17.5989 7.19702 17.3503C7.19702 17.0971 7.29217 16.8538 7.46259 16.6687L10.6931 13.3816L10.6942 13.3804L12.0124 12.0347L10.5996 10.6189L9.26664 11.9797L9.26548 11.9809L6.02665 15.2764L6.01854 15.2847L6.01062 15.2931C5.48764 15.8505 5.19702 16.5864 5.19702 17.3503C5.19702 18.1143 5.48768 18.8501 6.01062 19.4074L6.02633 19.4241L6.04279 19.4401C6.58572 19.968 7.31274 20.2633 8.06982 20.2633C8.82684 20.2633 9.554 19.968 10.097 19.4401L10.1069 19.4305L10.1166 19.4205L14.691 14.7188ZM9.37409 9.39092L4.83902 14.0169C3.99007 14.9097 3.51611 16.0961 3.51611 17.3303C3.51611 18.5642 3.98983 19.7503 4.83839 20.643C5.26078 21.0715 5.7636 21.4118 6.31788 21.6444C6.87446 21.878 7.47171 21.9983 8.07483 21.9983C8.67795 21.9983 9.27519 21.878 9.83178 21.6444C10.3882 21.4109 10.8928 21.0689 11.3162 20.6381L11.3166 20.6377L15.9149 15.9453L17.3278 17.361L12.7441 22.0384L12.7432 22.0393C12.1338 22.6597 11.4071 23.1523 10.6057 23.4886C9.80431 23.8249 8.94398 23.9983 8.07483 23.9983C7.20567 23.9983 6.34535 23.8249 5.54394 23.4886C4.74249 23.1523 4.01596 22.6597 3.40654 22.0393L3.40131 22.034L3.39616 22.0286C2.18921 20.7629 1.51611 19.0801 1.51611 17.3303C1.51611 15.5805 2.18921 13.8976 3.39616 12.6319L3.40572 12.6219L3.40578 12.622L7.96125 7.97516L9.37409 9.39092ZM18.7277 15.9325L17.3148 14.5167L18.4056 13.4036C18.7922 13.0092 19.4253 13.0027 19.8198 13.3893C20.2142 13.7758 20.2207 14.409 19.8341 14.8034L18.7277 15.9325ZM11.9992 9.1901L13.412 10.6059L14.4242 9.57254C14.8107 9.178 14.8041 8.54487 14.4096 8.1584C14.0151 7.77194 13.3819 7.77848 12.9955 8.17302L11.9992 9.1901Z"
      fill={props.color}
    />
    <path
      d="M1 1.00659L23 23.052"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgRemoveAttachmentLarge.displayName = 'SvgRemoveAttachmentLarge';
const RemoveAttachmentLarge = withForgeIconProps(SvgRemoveAttachmentLarge, {
  name: 'RemoveAttachment',
  usage: 'Use to remove an attachment.',
  related: 'attach, paperclip, clip, file, edit',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default RemoveAttachmentLarge;
